import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import{ Dth } from './dth';  
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dth',
  templateUrl: './dth.component.html',
  styleUrls: ['./dth.component.css']
})
export class DthComponent implements OnInit {
 
  constructor(private service:AppService,private config:NgbCarouselConfig) {
    config.interval=2000,
    config.wrap=true,
    config.keyboard=false
  }

  dth=new Dth();
  operatorList:[];
  rchprocess:boolean=false;
  errorMsg:any;
  orderHistory:boolean=false;
  paymentHistory:boolean=false;
  date : Date = new Date(); 

  ngOnInit() { 
    this.getAllOperator(); 
  }

  getAllOperator() {  
    this.rchprocess=true; 
    this.service.post('/getOperatorList',{type:"dth"}).subscribe(data => {
        if(data[0].error=='0')
        {
            this.operatorList=data[0].result;
        }
        this.rchprocess=false;
      },
      error =>{
        alert(error.errorDesc); 
        console.log(error); 
        this.rchprocess=false;
      }
    );
  }

  getHistory(){
      this.orderHistory=true;
  }

    rechargeBack(){
      this.orderHistory=false;
    }

    makeAnotherRch(){
      this.orderHistory=false;
      this.paymentHistory=false;
      this.dth=new Dth();
    }

    doRecharge(){
      var chkLogin=this.service.isLoggedIn();

      if(chkLogin){
        var ddd=confirm("Are you want to confirm this recharge.");

        if(ddd){ 
          this.rchprocess=true; 
          this.errorMsg='';
          var data={key:this.service.getAuthorizationToken(),mobile_no:this.dth.card_number,service_provider:this.dth.operator,recharge_type:0,amount:this.dth.amount,referance_no:0};
          this.service.post('/doRecharge',data).subscribe(data => {
              if(data[0].error=='0')
              {
                console.log(data[0].msg);
                this.paymentHistory=true;
                this.orderHistory=false;
              }else{
                console.log(data[0].msg);
              }
              alert(data[0].msg);
              this.rchprocess=false; 
            },
            error =>{
              alert(error.errorDesc); 
              console.log(error); 
              this.rchprocess=false; 
            }
          );  
        }
      }
      else{
        alert("Please first login.");
      }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
